// ModuloCompras.jsx
import React from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Container,
  Avatar,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  Grid,
  CssBaseline,
  Stack,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SideMenu from '../../../components/SideMenu';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../../dashboard/theme/customizations';
import AppTheme from '../../../shared-theme/AppTheme';
import { StyledCellHeader } from '../../../components/StyledCellHeader';
import { Add } from '@mui/icons-material';
import OrdenesCompras from './ordenescompra';
import TableProveedores from './proveedores/index';
import RecepcionOrdenCompra from './recepcion';
import FacturasProveedores from './facturasproveedores';
import PagosProveedores from './pagos';

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
  };

const ModuloCompras = (props) => {
  const [tab, setTab] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
            <SideMenu />
            <AppNavbar />
            {/* Main content */}
            <Box
            component="main"
            sx={(theme) => ({
                flexGrow: 1,
                backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
                overflow: 'auto',
            })}>
            <Stack
                spacing={2}
                sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
                }}>
                <Header parent={"Logistica y Almacenes"} child={"Compras"}/>

        
                <Container maxWidth="lg" sx={{ mt: 5 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" px={2} py={2}>
                        <Typography variant="h4" fontWeight={700} mb={2}>
                        Compras
                        </Typography>
                    </Stack>

                    <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }} variant="scrollable" scrollButtons="auto" >
                        <Tab label="Órdenes de Compra" sx={{fontSize:17, fontWeight:"bold"}}/>
                        <Tab label="Proveedores" sx={{marginLeft:2, fontSize:17, fontWeight:"bold"}}/>
                        <Tab label="Recepciones" sx={{marginLeft:2, fontSize:17, fontWeight:"bold"}}/>
                        <Tab label="Facturas de Proveedores" sx={{marginLeft:2, fontSize:17, fontWeight:"bold"}}/>
                        <Tab label="Pagos" sx={{marginLeft:2, fontSize:17, fontWeight:"bold"}}/>
                    </Tabs>

                    {tab === 0 && <OrdenesCompras/>}
                    {tab === 1 && <TableProveedores/>}
                    {tab === 2 && <RecepcionOrdenCompra/>}
                    {tab == 3 && <FacturasProveedores/>}
                    {tab == 4 && <PagosProveedores/>}
                </Container>

            </Stack>
          </Box>
        </Box>
    </AppTheme>
  );
};

export default ModuloCompras;
